<template>
  <div class="search-wrap">
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="0"
      class="search-list-430 search-wrapper-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem label="">
          <Input
            v-model="searchConds.acctNo"
            clearable
            placeholder="请输入账号编号"
            class="search-input-430"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="searchConds.acctName"
            clearable
            placeholder="请输入账号名称"
            class="search-input-430"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="searchConds.configId"
            clearable
            placeholder="请输入分账模板编号"
            class="search-input-430"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="searchConds.configName"
            clearable
            placeholder="请输入分账规则名称"
            class="search-input-430"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Select
            class="search-select-430"
            placeholder="请选择入账类型"
            v-model="searchConds.inAcctType"
          >
            <Option
              v-for="item in inAcctTypeList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="">
          <Select
            v-model="searchConds.accountingType"
            class="search-select-430"
            placeholder="请选择账期周期"
          >
            <Option
              v-for="item in accountingType"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <Button type="primary" style="margin-right: 16px" @click="handleSearch"
          >查询</Button
        >
        <Button @click="handleReset">重置</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
import orderCenterApi from '@/request/orderCenter/index.js';

export default {
  components: {

  },
  data() {
    return {
      searchConds: {
        acctNo: '',
        acctName: '',
        configId: '',
        configName: '',
        // bankId: -1,
        inAcctType: -1,
        accountingType: -1
      },
      bankList: [{
        value: -1,
        label: '全部'
      }],

      accountingType: [{
        value: -1,
        label: '全部'
      }, {
        value: 1,
        label: '按月考勤节次'
      }, {
        value: 2,
        label: '按固定时长'
      }],
      inAcctTypeList: [{
        value: -1,
        label: '全部'
      }, {
        value: 1,
        label: '平安银行'
      }, {
        value: 2,
        label: '花都工行'
      }, {
        value: 3,
        label: '微信线下'
      }]// inAcctType  入账类型 1-平安 2-花都工行 3-微信线下
    };
  },
  created() {
    // this.getFindBankList();
  },
  methods: {
    // 获取银行列表
    // async getFindBankList() {
    //   const res = await orderCenterApi.getFindBankList();

    //   if (res.status == 200) {
    //     const arr = res.message.map(item => {
    //       return {
    //         value: item.bankId,
    //         label: item.bankName
    //       };
    //     });
    //     this.bankList = [...this.bankList, ...arr];
    //   }
    // },
    handleSearch() {
      const data = JSON.parse(JSON.stringify(this.searchConds));
      for (const k in data) {
        if (data[k] == -1) {
          delete data[k];
        }
      }
      this.$emit('on-search', data);
    },
    handleReset() {
      this.searchConds = {
        acctNo: '',
        acctName: '',
        configId: '',
        configName: '',
        // bankId: -1,
        inAcctType: -1,
        accountingType: -1
      };
      this.handleSearch();
    }
  }

};
</script>

<style>
</style>
